module.exports = __webpack_public_path__ + "img/logo.343dd81d.png";